import React, { useEffect, useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Spinner,
    Row,
    Col
} from "reactstrap";

import BasicModal from '../../../../components/Modals/BasicModal'
import SelectInstitution from './SelectInstitution';
import { getInstitutions, getCredentialTypes } from "../../../../network/ApiAxios";
import SelectCredentials from './SelectCredentials';
import secureLocalStorage from "react-secure-storage";

const ManagementInformation = (props) => {
    const credential = props.credential
    const formDisabled = props.formDisabled
    const setCredential = props.setCredential
    const [showModal, setShowModal] = useState(false)
    const [warning, setWarning] = useState("")
    const [showInstitutions, setShowInstitutions] = useState(false)
    const [selectOptions, setSelectOptions] = useState([])
    const [selectCredentialOptions, setSelectCredentialOptions] = useState([])
    const user = JSON.parse(secureLocalStorage.getItem("user"));

    useEffect(() => {

        const runAsync = async () => {

            let params = {
                filter: {
                    account: user.account
                }
            }

            const response = await getInstitutions(params);
            const { data } = response;

            if (data.success && data.institutions.length > 0) {
                setSelectOptions(data.institutions)
                setShowInstitutions(true)
            }
        }

        runAsync();

        const runAsyncCredentials = async () => {

            let params = { visible: true }

            const response = await getCredentialTypes(params);
            const { data } = response;

            if (data.success && data.credentialTypes.length > 0) {
                setSelectCredentialOptions(data.credentialTypes)
            }

        }

        runAsyncCredentials();

    }, [])


    return (
        <>
            {/* Address */}
            <h6 className="heading-small text-muted mb-4">
                Management information
            </h6>
            <div className="pl-lg-4">

                <Row>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-type"
                            >
                                Credential Type
                            </label>

                            <SelectCredentials
                                typeId={credential?.type?._id}
                                formDisabled={formDisabled}
                                setCredential={setCredential}
                                selectOptions={selectCredentialOptions}
                                credential={credential} />

                        </FormGroup>
                    </Col>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-institution"
                            >
                                Institution
                            </label>

                            {!showInstitutions ?
                                <div className="text-center p-1">
                                    <Spinner size="lg" />
                                </div>
                                :
                                <SelectInstitution
                                    institutionId={credential?.institution?._id}
                                    formDisabled={formDisabled}
                                    setCredential={setCredential}
                                    selectOptions={selectOptions}
                                    credential={credential} />
                            }

                        </FormGroup>
                    </Col>
                </Row>

            </div>

            <BasicModal
                title="Warning"
                message={warning}
                showModal={showModal}
                setShowModal={setShowModal} />

        </>
    )
}

export default ManagementInformation;